import {
    ASSESSMENTRUNQUESTION_INDEX,
    GRADING_PARTY_INDEX,
    USERQUESTION_INDEX,
} from 'grading/src/store/common/search/constants';

import { difference } from 'lodash';

export const KEY_CODES = {
    ENTER: 13,
    SPACE: 32,
    COMMA: 188,
    PERIOD: 190,
};

export const Categories = {
    STIMULUS: 'stimulus',
    QUESTION: 'question',
};

export const Context = {
    PREVIEW: 'preview',
    AUDIO_SCRIPT: 'previewAudioScript',
    DELIVERY: 'delivery',
    CONTEXT_VIEW_GRADING_QUESTION_PREVIEW: 'viewGradingQuestionPreview',
};

export enum CustomFieldDefinitionTypes {
    QUESTION = 'content_question',
    SECTION = 'content_qti_section',
    QUESTION_SET = 'content_structure_assessment',
    CONTENT_SOUND = 'content_sound',
}

export const ContentTypes = {
    QUESTION_SET: 'content_structure_assessment',
    SECTION: 'content_qti_section',
    QUESTIONS: 'questions',
    DOCUMENT: 'content_nativehtml',
    QUESTION: 'content_question',
};

export const ContentTypesTemplates = {
    [ContentTypes.SECTION]: 'section_template',
    [ContentTypes.QUESTION]: 'question_template',
    [ContentTypes.QUESTION_SET]: 'question_set_template',
};

export const ITEM_BANK_CONTENT_PRIVACY_PUBLIC = 'public';
export const ITEM_BANK_CONTENT_PRIVACY_PRIVATE = 'private';
export const ITEM_BANK_CONTENT_PRIVACY_USER_DEFINED = 'user-defined';
export const VALID_ITEM_BANK_CONTENT_PRIVACY_MP_PROP_VALUES = [
    ITEM_BANK_CONTENT_PRIVACY_PUBLIC,
    ITEM_BANK_CONTENT_PRIVACY_PRIVATE,
    ITEM_BANK_CONTENT_PRIVACY_USER_DEFINED,
];

export const presetType = {
    CONTENT_STYLE: 'content_preset_content_style',
    SYMBOL_PALETTE: 'content_preset_special_character_palette',
};

export const PublishStatuses = {
    LIVE: 'live',
    DRAFT: 'draft',
};

export enum BlocklistWorkspaces {
    SOFTWARE_BLOCKLIST = 'software_blocklist',
    DEVICE_IDS_BLOCKLIS = 'deviceIds_blocklist',
}

export const GradingUpdateEvent = {
    scoreUpdate: 'scoreUpdate',
    explanationLockUpdate: 'explanationLockUpdate',
    explanationUpdate: 'explanationUpdate',
    annotationsUpdate: 'annotationsUpdate',
    headerUpdate: 'headerUpdate',
    showReloadUpdate: 'showReloadUpdate',
    workspaceUpdate: 'workspaceUpdate',
    gradingPartyIndexUpdate: 'gradingPartyIndexUpdate',
    assessmentInfoUpdate: 'assessmentInfoUpdate',
    userQuestionIndexUpdateForCandidate: 'userQuestionIndexUpdateForCandidate',
    assessmentRunDraftUpdate: 'assessmentRunDraftUpdate',
    assessmentRunQuestionIndexUpdate: 'assessmentRunQuestionIndexUpdate',
    studentReportUpdate: 'studentReportUpdate',
    auditTrailUpdate: 'auditTrailUpdate',
    quickMarkChanged: 'quickMarkChanged',
    plagiarismUpdate: 'plagiarismUpdate',
    correctedQuestionsUpdate: 'correctedQuestionsUpdate',
    assessmentRunSessionUpdate: 'assessmentRunSessionUpdate',
    submissionDeletedUpdate: 'submissionDeletedUpdate',
    assessmentRunFeedbackLockUpdate: 'assessmentRunFeedbackLockUpdate',
    assessmentRunFeedbackUpdate: 'assessmentRunFeedbackUpdate',
};

export const RubricsUpdateEvent = {
    contentRubricUpdate: 'contentRubricUpdate',
    contentRubricLockUpdate: 'contentRubricLockUpdate',
};

export const categories = {
    STIMULUS: 'stimulus',
};

export const qtiTypes = {
    MULTIPLE_CHOICE: 'content_question_qti2_multiple_choice',
    MULTIPLE_RESPONSE: 'content_question_qti2_multiple_response',
    TEXT_ENTRY: 'content_question_qti2_text_entry',
    TEXT_ENTRY_NUMERIC: 'content_question_qti2_text_entry_numeric',
    TEXT_ENTRY_MATH: 'content_question_qti2_text_entry_math',
    INLINE_CHOICE: 'content_question_qti2_inline_choice',
    TRUE_FALSE: 'content_question_qti2_true_false',
    MATCH: 'content_question_qti2_match',
    COMPOSITE_EDITOR: 'content_question_qti2_composite_editor',
    GRAPHIC_GAP_MATCH: 'content_question_qti2_graphicgapmatch',
    HOTSPOT: 'content_question_qti2_hotspot',
    CODE_EDITOR_COMPILED: 'content_question_qti2_code_editor_compiled',
    GRAPHIC_GAP_MATCH_V2: 'content_question_qti2_graphicgapmatch_v2',
    GAP_MATCH: 'content_question_qti2_gapmatch',
    TEXT_ENTRY_GRAPHIC: 'content_question_qti2_text_entry_graphic',
    EXTENDED_TEXT: 'content_question_qti2_extendedtext',
    TEXT_AREA: 'content_question_qti2_text_area',
    UPLOAD: 'content_question_qti2_upload',
    CODE_EDITOR: 'content_question_qti2_code_editor',
    EXTENDED_TEXT_MATH: 'content_question_qti2_extendedtext_math',
    AUDIO_RECORD: 'content_question_qti2_audio_record',
    AUDIO_SCRIPT: 'content_question_qti2_text_audio_script',
    ORAL: 'content_question_qti2_oral',
    ORAL_INTERACTIVE: 'content_question_qti2_oral_interactive',
    CONTENT_BLOCK: 'content_question_qti2_content_block',
    COMPOSITE_FORM: 'content_question_qti2_composite_form',
    ORAL_SPEAKING: 'content_question_qti2_oral_speaking',
    LTI_TOOL: 'content_question_qti2_lti_tool',
    NUMERICAL_SIMULATION: 'content_question_qti2_numeric_simulations',
    SYMBOLIC_MATH: 'content_question_qti2_symbolic_math',
    TEXT_ENTRY_WORD_FORMATION: 'content_question_qti2_text_entry_word_formation',
    O365_SPREADSHEET: 'content_question_qti2_o365_spreadsheet',
    O365_SPREADSHEET_MANUAL_MARKING: 'content_question_qti2_o365_spreadsheet_manual',
    QUESTION_STIMLULUS: 'content_question_qti2_stimulus',
    DRAWING: 'content_question_qti2_drawing',
    PCI_STIMULUS: 'pci_stimulus',
    PCI_STIMULUS_OBJECT_TYPE: 'content_question_qti2_pci_stimulus',
};

// Both the automatically-marked and manually-marked O365 spreadsheet question types must be
// treated identically when rendering the spreadsheet viewer, model answers, and question preview.
export const spreadsheetQtiTypes = [qtiTypes.O365_SPREADSHEET, qtiTypes.O365_SPREADSHEET_MANUAL_MARKING];

export const isSpreadsheetQuestionType = (questionType: string | undefined): boolean => (
    spreadsheetQtiTypes.includes(questionType as string)
);

export const qtiTypeVariations = {
    GAP_MATCH_HEADINGS: 'content_question_qti2_gapmatch_headings',
};

export const QTIElementTypes = {
    QUESTION_REF: 'questionRef',
    SECTION_REF: 'sectionRef',
    INLINE_SECTION: 'sectionInline',
};
export const CONTENT_QTI_SECTION = 'content_qti_section';
export const CONTENT_STRUCTURE_ASSESSMENT = 'content_structure_assessment';

export const SIMPLE_DATE_FORMAT_STRING_NO_SECONDS = 'YYYYMMDDHHmm';
export const SIMPLE_DATE_FORMAT_STRING_WITH_SECONDS = 'YYYYMMDDHHmmss';

export enum AWSRumCustomEvents {
    OPEN_PRINT_VIEW = 'open_print_view',
    TOGGLE_DETAILS_PANEL = 'toggle_details_panel',
    TOGGLE_STRUCTURE_EDITOR = 'toggle_structure_editor',
    SAVE_SELECTED_DAK_CONFIG = 'save_selected_dak_config',
    TOGGLE_SIDEBAR = 'toggle_sidebar',
    TOGGLE_DAK_OVERLAY = 'toggle_dak_overlay',
}

export const CONTENT_ITEM_TEMPLATES = 'content_item_templates';
export const CONTENT_QTI_SECTION_IB_TEMPLATE = 'content_qti_section_ib_template';
export const CONTENT_QUESTION_TEMPLATE = 'content_question_template';

export enum WorkspaceIds {
    AUTHOR_EDIT = 'author_edit'
}

export enum DateFormats {
    DATE_FORMAT_STRING_NO_SECONDS = 'DD-MM-YYYY, HH:mm A',
    DATE_FORMAT_STRING_DETAILED_MONTH = 'MMM DD, YYYY h:mm A',
}

export enum workspaceID {
    PLAN_ASSESSMENT_RUN_QUESTIONS = 'plan_assessmentrun_questions',
    EVALUATE_ASSESSMENT_RUN_QUESTIONS = 'evaluate_assessmentrun_questions',
    PLAN_MARKING = 'plan_marking',
    PLAN_REVIEW = 'plan_review_candidates',
    PLAN_OVERVIEW = 'plan_overview_per_candidate',
    EVALUATE_REVIEW = 'evaluate_review_candidates',
    EVALUATE_OVERVIEW = 'evaluate_overview_per_candidate',
    EVALUATE_MARKING = 'evaluate_marking',
    MAJOR_VERSIONS = 'major_versions',
    // Used by platform-ia to embed Author in an iframe
    QUESTION_SET_SUMMARY = 'question_set_summary',
}

export const manualMarkedQuestionTypes = [
    qtiTypes.EXTENDED_TEXT,
    qtiTypes.TEXT_AREA,
    qtiTypes.UPLOAD,
    qtiTypes.CODE_EDITOR,
    qtiTypes.EXTENDED_TEXT_MATH,
    qtiTypes.AUDIO_RECORD,
    qtiTypes.ORAL,
    qtiTypes.ORAL_INTERACTIVE,
    qtiTypes.LTI_TOOL,
    qtiTypes.ORAL_SPEAKING,
    qtiTypes.DRAWING,
    qtiTypes.O365_SPREADSHEET_MANUAL_MARKING,
];

export const notMarkedQtiTypes = [
    ContentTypes.DOCUMENT,
    qtiTypes.COMPOSITE_FORM,
];

export const questionTypesMarkedAsNew = [
    ContentTypes.DOCUMENT,
];

export enum QuestionCardUiSectionTypes {
    AUTOMATICALLY_MARKED_QUESTION_TYPES = 'automaticallyMarkedQtiTypes',
    MANUALLY_MARKED_QUESTION_TYPES = 'manualMarkedQuestionTypes',
    NOT_MARKED_QUESTION_TYPES = 'notMarkedQtiTypes',
}

export type QuestionCardUiSection = QuestionCardUiSectionTypes;

export const automaticallyMarkedQtiTypes = difference(
    Object.values(qtiTypes),
    manualMarkedQuestionTypes,
    notMarkedQtiTypes,
    [qtiTypes.QUESTION_STIMLULUS, qtiTypes.PCI_STIMULUS, qtiTypes.PCI_STIMULUS_OBJECT_TYPE]
);

interface WorkspaceLevel {
    id: string;
    level: number;
}
export const workspaceLevels: WorkspaceLevel[] = [
    { id: workspaceID.PLAN_OVERVIEW, level: 2 },
    { id: workspaceID.PLAN_MARKING, level: 3 },
    { id: workspaceID.EVALUATE_OVERVIEW, level: 2 },
    { id: workspaceID.EVALUATE_MARKING, level: 3 },
];

export const newWorkspaceLevels: WorkspaceLevel[] = [
    { id: workspaceID.PLAN_OVERVIEW, level: 2 },
    { id: workspaceID.EVALUATE_OVERVIEW, level: 2 },
    { id: workspaceID.EVALUATE_ASSESSMENT_RUN_QUESTIONS, level: 2 },
    { id: workspaceID.PLAN_ASSESSMENT_RUN_QUESTIONS, level: 2 },
];

export const REDIRECTABLE_DATA_TYPES = [
    ASSESSMENTRUNQUESTION_INDEX,
    USERQUESTION_INDEX,
    GRADING_PARTY_INDEX,
];

export const featureWorkspaceHeaderEvaluateReviewCandidates = 'feature_workspaceHeader_evaluate_review_candidates';

export const VIEW_TYPES = {
    DEFAULT: 'default',
    DETAIL: 'detail',
};

export const SELECTION_COLUMN = {
    ref: 'selection',
    name: '',
    type: 'boolean',
    sortDisabled: true,
};

export const LABELS_COLUMN = {
    ref: 'labels',
    name: 'labels',
    type: 'string',
    sortDisabled: true,
};

export enum HEADER_FILTER {
    SHOW_SELECTED = 'SHOW_SELECTED',
    SHOW_ALL = 'SHOW_ALL',
    SELECT_ALL = 'SELECT_ALL',
    DESELECT_ALL = 'DESELECT_ALL',
}

export const MarketPlaces = {
    fjord: 'fjord',
};

export const CUSTOM_QUERY_KEY = 'customQuery';

export const TEXT_INPUT_MAX_LENGTH = 400;
